import React from 'react';
import 'assets/sass/dashboard/buy-and-sell/ButtonAction.scss';

export function ButtonAction({className, image, label, onClick}) {
    return (
        <div className={"button-action " + (className || '')} onClick={onClick}>
            <figure className="button-image">
                {image}
            </figure>
            <div className="button-content">
                {label}
            </div>
        </div>
    );
}
